import { Checkbox, FormControlLabel, FormControlLabelProps, SxProps, Theme } from '@mui/material';
import { ChangeEvent, FC, ReactNode } from 'react';

type VyCheckboxProps = {
  checked: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  label?: ReactNode;
  disabled?: boolean;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  labelWrapperSx?: SxProps<Theme>;
};

export const VyCheckbox: FC<VyCheckboxProps> = ({
  checked,
  onChange,
  label,
  labelPlacement,
  disabled,
  labelWrapperSx = {},
}) => (
  <FormControlLabel
    sx={labelWrapperSx}
    disabled={disabled}
    control={<Checkbox checked={checked} onChange={onChange} sx={{ color: '#07105F !important' }} />}
    label={label}
    labelPlacement={labelPlacement}
  />
);
